import { Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import * as CitiesActions from '@app/shared/store/actions';

import { CitiesService } from '@app/shared/services';

@Injectable()
export class CityesEffects {
  getCityes$ = createEffect(() =>
    this.actions$.pipe(
      ofType<CitiesActions.GetCities>(
        CitiesActions.CitiesActionTypes.GET_CITIES
      ),
      switchMap((action) => {
        return this._CitiesService.getCities().pipe(
          map((resp) => {
            return new CitiesActions.GetCitiesSuccess(resp);
          }),
          catchError((error) => {
            return of(new CitiesActions.GetCitiesError(error));
          })
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private _CitiesService: CitiesService
  ) {}
}
